export default (() => {
  document.querySelectorAll('.js-qrcode').forEach(function (dom) {
    if (typeof QRCode === 'undefined') {
      return
    }
    let options = JSON.parse(dom.dataset.qrcode || '{}')
    options.text = options.text || dom.dataset.value
    // eslint-disable-next-line no-undef
    new QRCode(dom, options)
  })
})()
